import "./index.css"
import { ThemeProvider } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import theme from "./theme/mui"
import RoomProvider from "./Context/RoomContext"
import React from "react"
import "./translations/i18n"

function RootElement({ element }) {
  return (
    <div className="App">
      <RoomProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {element}
        </ThemeProvider>
      </RoomProvider>
    </div>
  )
}
export default RootElement
